// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/en/spring-constant/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const springConstantEN: PageEntry = {
  id: "post.federkonstante",
  locale: "en",
  slug: "spring-constant",
  seo: {
    title: "Glossary: Spring constant simply explained | Dietz GmbH",
    description: "The spring constant is a physical parameter that describes the stiffness of a spring. It indicates how much force is required to stretch or compress the spring by one unit. The spr",
  },
  type: "post",
  h1: "Glossary: Spring constant simply explained",
  intro: "The spring constant is a physical parameter that describes the stiffness of a spring. It indicates how much force is required to stretch or compress the spring by one unit. The spring constant is measured in Newtons per metre (N/m). A higher spring constant means that the spring is stiffer and requires more force to stretch or compress it, while a lower spring constant indicates a softer spring. Precise knowledge of the spring constant is crucial for the design of spring systems in various applications, from automotive chassis to industrial machinery.",
  blocks: [

  ],
};
